import PublicUtil from './publicUtil'
export default {
  install: function (Vue, options) {
    // 封装常用的公用方法
    Vue.prototype._pub = PublicUtil()
  }
}



// WEBPACK FOOTER //
// ./src/common/js/install.js